export const LOG_IN_I18N = {
  action: {
    logout: $localize`:@@pages.logIn.action.logout:ログアウト中…`,
    preLogin: $localize`:@@pages.logIn.action.preLogin:ログイン`,
    postLogin: $localize`:@@pages.logIn.action.postLogin:情報取得中…`,
    login: $localize`:@@pages.logIn.action.login:ログイン中…`,
    navigate: $localize`:@@pages.logIn.action.navigate:移動中…`,
    loginAs: (username: string) =>
      $localize`:@@pages.logIn.action.loginAs:${username}:USERNAME:としてログイン`,
  },
  loginWithDifferentAccount: $localize`:@@pages.logIn.loginWithDifferentAccount:別のアカウントでログイン`,
} as const;
